import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);





  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>



      <div className='tejbhan1'>
        <marquee className='tejbhan' width="100%" direction="left" height="" style={{ position: "" }}>
          <b className='' style={{ fontSize: "17px", color: "white", marginTop: "90px" }}>
            <b style={{ color: "" }}> ✅ अन्य सुविधा - ECG | USG | X-Ray | ICU | Ventilator । फामेसर्सी । पैथालॉली </b>
            ✅   सभी प्रमुख हेल्थ इंश्योरेंस कंपनियों और थर्ड पार्टी एडमिनिस्ट्रेटर (TPA) के ज़रिए कैशलेस इलाज की सुविधा उपलब्ध है।
            ✅ विशेषज्ञ परामर्श ओ.पी.डी.
            ✅ भर्ती की सुविधा-जनरल वार्ड, सेमी प्राइवेट, प्राइवेट वार्ड
            ✅ माडयूलर O.T. (दूरबीन से ऑपरेशन की सुविधा)
            ✅ आपालकालीन सुविधाएं 24X7
            ✅ सभी प्रकार के ट्रामा का सम्पूर्ण इलाज एवं ऑपरेशन
          </b>
        </marquee>
      </div>

      <header className="main-header " >
        <div className="header-upper" >
          <div className="auto-container" >
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <ul className="header-social_box mt-lg-5" style={{ borderRight: "none" }}>
                <li className='mb-lg-5'><Link style={{ color: "black" }} to="https://www.instagram.com/satnaswastikhospital/" target="_blank" className="fa-brands fa-instagram fa-fw" /></li>
                <li><a style={{ color: "black" }} href="https://www.facebook.com/share/1AmFAs294K/" target="_blank" className="fa-brands fa-facebook-f fa-fw" /></li>
                <li><a style={{ color: "black" }} href="https://youtube.com/@swastikhospital-n3b?si=eJE49e2e08PFU_yT" target="_blank" className="fa-brands fa-youtube fa-fw" /></li>
              </ul>

              <div className="upper-right d-flex flex-wrap">
                <div className="upper-column info-box">
                  <div className="icon-box kkk"  ><span className="flaticon-clock" /></div>
                  <ul>
                    <li><strong>24 Hours</strong></li>
                    <li> <strong style={{ color: "black" }}> 24/7 Emergency Services </strong></li>
                  </ul>
                </div>
                <div className="upper-column info-box">
                  <div className="icon-box"><span className="flaticon-send-mail" /></div>
                  <ul>
                    <li><strong>
                      <a href='tel: +91 7672326319' style={{ color: "black" }}> +91 7672326319</a>
                      <a href='tel: +91 7509182172' style={{ color: "black" }}>, +91 7509182172</a>
                    </strong></li>
                    <li> <strong style={{ color: "black" }}> <a href="mailto:satnaswastikhospital@gmail.com" style={{ color: "black" }}>satnaswastikhospital@gmail.com</a> </strong></li>
                  </ul>
                </div>
                <div className="upper-column info-box">
                  <div className="icon-box"><span className="flaticon-placeholder" /></div>
                  <ul>
                    <li><strong><a href='https://share.google/Ekv0nUxkNaGImU8TX' target="_blank" style={{ color: "black" }}>सतना स्वास्तिक हॉस्पिटल</a></strong></li>
                    <li> <strong> <a href='https://share.google/Ekv0nUxkNaGImU8TX' target="_blank" style={{ color: "black" }}> पन्नीलाल चौक, सतना (म.प्र.) </a> </strong> </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>


      <header className="header-area stricky" style={{ backgroundColor: "#def8f7", marginTop: "10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="outer-box clearfix">
                <div className="logo">
                  <Link to="/">
                    <img src="https://res.cloudinary.com/dedml8dsw/image/upload/v1770098845/logo_3_dlcivu.jpg" alt="Awesome Logo" style={{ width: "200px", height: "67px", marginTop: "20px" }} />
                    {/* style={{ width: "90px", height: "70px" }} */}
                    {/* ./assets/public/website/assets/images/Untitled design (12).png */}
                  </Link>
                </div>
                <nav className="main-menu">
                  <div className="navbar-header">
                    <button
                      id="mytogglebtn"
                      v
                      className="navbar-toggle collapsed"
                      data-toggle="collapse"
                      data-target="#menu"
                      onClick={closemenu}
                    >
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />

                    </button>
                  </div>
                  <div className="navbar-collapse collapse clearfix" id="menu" >
                    <ul className="navigation clearfix" style={{ fontFamily: "Arial, Helvetica, sans-serif;" }} >
                      <li className="current" >
                        <Link to="/" onClick={closemenu} className=''>
                          Home
                        </Link>
                      </li>

                      <li className="dropdown">
                        <Link to="/about-us" onClick={closemenu}>About Us</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/about-us" onClick={closemenu}>
                              About Us
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="/our-team" onClick={closemenu}>
                              Our Doctor
                            </Link>
                          </li> */}
                          {/* <li>
                            <Link to="/" onClick={closemenu}>
                              Why SS Hospital
                            </Link>
                          </li> */}
                          <li>
                            <Link to="/faq" onClick={closemenu}>
                              FAQ
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>
                      <li className="dropdown">
                        <Link to="/services" onClick={closemenu}>Services</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/orthopedic" onClick={closemenu}>
                              Orthopedic
                            </Link>
                          </li>
                          <li>
                            <Link to="/general-surgery" onClick={closemenu}>
                              General Surgery
                            </Link>
                          </li>
                          <li>
                            <Link to="/general-medicine" onClick={closemenu}>
                              General Medicine
                            </Link>
                          </li>
                          <li>
                            <Link to="/neurology" onClick={closemenu}>
                              Neurology
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>

                      <li className="">
                        <Link to="/our-doctor" onClick={closemenu}>
                          Our Doctor
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/blog" onClick={closemenu}>
                          Our Blog
                        </Link>
                      </li>

                      {/* <li className="">
                        <Link to="/gallery" onClick={closemenu}>
                          Gallery
                        </Link>
                      </li> */}
                       <li className="dropdown">
                        <Link to="/gallery" onClick={closemenu}>Our Gallery</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/gallery" onClick={closemenu}>
                              Image Gallery
                            </Link>
                          </li>
                          <li>
                            <Link to="/video-gallery" onClick={closemenu}>
                              Video Gallery
                            </Link>
                          </li>
                          
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>


                      <li className="">
                        <Link to="/contact-us" onClick={closemenu}>
                          Contact Us
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/appointment" onClick={closemenu}>
                          Book Appointment
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>


      <div className="xs-sidebar-group info-group">
        <div className="xs-overlay xs-bg-black" />
        <div className="xs-sidebar-widget">
          <div className="sidebar-widget-container">
            <div className="close-button">
              <span className="fa fa-solid fa-xmark fa-fw" />
            </div>
            <div className="sidebar-textwidget">
              {/* Sidebar Info Content */}
              <div className="sidebar-info-contents">
                <div className="content-inner">
                  {/* Title Box */}
                  <div className="title-box">
                    <h5>Shopping <span>Bag</span></h5>
                    <div className="price">$15 from free economy shipping</div>
                  </div>
                  {/* Empty Cart Box */}
                  <div className="empty-cart-box">
                    {/* No Product */}
                    <div className="no-cart">
                      <span className="icon fa fa-sharp fa-solid fa-cart-shopping fa-fw" />
                      No products in cart.
                    </div>
                  </div>
                  {/* Lower Box */}
                  <div className="lower-box">
                    <h5>Popular <span>Suggestions</span></h5>
                    {/* Post Block */}
                    <div className="post-block">
                      <div className="inner-box">
                        <div className="image">
                          <img src="assets/images/resource/post-thumb-1.jpg" alt />
                        </div>
                        <h6><a href="#">Hematology Machine</a></h6>
                        <div className="rating">
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                        </div>
                        <div className="price-box">$125</div>
                        <a className="theme-btn bag-btn" href="#">add to bag</a>
                      </div>
                    </div>
                    {/* Post Block */}
                    <div className="post-block">
                      <div className="inner-box">
                        <div className="image">
                          <img src="assets/images/resource/post-thumb-2.jpg" alt />
                        </div>
                        <h6><a href="#">Dermatology</a></h6>
                        <div className="rating">
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                        </div>
                        <div className="price-box">$205</div>
                        <a className="theme-btn bag-btn" href="#">add to bag</a>
                      </div>
                    </div>
                    {/* Post Block */}
                    <div className="post-block">
                      <div className="inner-box">
                        <div className="image">
                          <img src="assets/images/resource/post-thumb-3.jpg" alt />
                        </div>
                        <h6><a href="#">Cardiology</a></h6>
                        <div className="rating">
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                          <span className="fa fa-star" />
                        </div>
                        <div className="price-box">$125</div>
                        <a className="theme-btn bag-btn" href="#">add to bag</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}
export default Hadear